<template>
	<div>
		<div class="toggleOption">
			<TnToggle
				v-model="showStoresWithStock"
				@change="toggleStoresWithStock"
			/>
			<TnParagraph>Butikker med varen på lager</TnParagraph>
		</div>
		<ul
			v-if="!loading && stores.length > 0"
			class="store-list"
		>
			<ECommerceClickAndCollectStoreCard
				v-for="store in stores"
				:key="store.id"
				:store="store"
				:active-store-id="activeStoreId"
				:button-text="content.storeCardButtonText"
				@card-activated="setActiveCard"
				@store-selected="setSelectedStore"
			/>
		</ul>
		<div
			v-else-if="!loading && storeError"
			class="flex"
		>
			<TnNotification
				type="error"
				title="Det har oppstått en feil"
			>
				{{ content.getStoresErrorMessage }}
			</TnNotification>
			<TnButton @click="getStoresWithProduct(hardwareProductId)">{{ content.tryAgainButtonText }}</TnButton>
		</div>
		<TnNotification
			v-else-if="!loading && stores.length < 1"
			title="Ingen butikker funnet."
			type="info"
		>
			{{ content.noStoresFoundMessage }}
		</TnNotification>
		<div
			class="store-list"
			v-else
		>
			<TnCard
				loading
				minHeight="62"
			/>
			<TnCard
				loading
				minHeight="62"
			/>
			<TnCard
				loading
				minHeight="62"
			/>
			<TnCard
				loading
				minHeight="62"
			/>
			<TnCard
				loading
				minHeight="62"
			/>
		</div>
	</div>
</template>

<script>
import clickAndCollectIntegration from "../../../../integrations/click-and-collect-integration";
import { mapState } from "vuex";
import { mapState as mapPiniaState } from "pinia";
import { useGeolocationStore } from "~/pinia/platform/geolocation/geolocation.ts";

export default defineNuxtComponent({
	name: "ECommerceClickAndCollectStoreSelector",
	props: {
		content: {
			type: Object,
			required: true,
		},
		hardwareProductId: {
			type: String,
			required: true,
		},
	},

	data: () => ({
		stores: [],
		activeStoreId: null,
		loading: true,
		storeError: false,
		showStoresWithStock: true,
	}),

	async mounted() {
		await this.getStoresWithProduct(this.hardwareProductId);
		this.activeStoreId = this.stores?.at(0)?.id;
	},

	computed: {
		...mapPiniaState(useGeolocationStore, ["position"]),
		...mapState("telenorbutikken", ["closestStore", "override"]),
	},

	methods: {
		async getStoresWithProduct(hardwareProductId) {
			this.loading = true;
			this.storeError = false;

			try {
				if (!this.closestStore?.address?.location.lat && !this.position?.latitude) {
					await useGeolocationStore().requestDevicePosition(false);
				}

				const data = await clickAndCollectIntegration.getStoresWithProduct(
					hardwareProductId,
					this.closestStore?.address?.location?.lat || this.position?.latitude || 0,
					this.closestStore?.address?.location?.lon || this.position?.longitude || 0,
					!this.showStoresWithStock,
				);

				this.stores = data;
			} catch (e) {
				if (e?.response?.data?.httpStatus === 404) {
					this.stores = [];
				} else {
					this.storeError = true;
					this.stores = [];
				}
			} finally {
				this.loading = false;
			}
		},
		async toggleStoresWithStock() {
			this.loading = true;
			await this.getStoresWithProduct(this.hardwareProductId);
			this.activeStoreId = this.stores?.at(0)?.id;
			this.loading = false;
		},
		setSelectedStore(store) {
			this.$emit("set-selected-store", store);
		},
		setActiveCard(id) {
			this.activeStoreId = id;
		},
	},
});
</script>

<style lang="scss" scoped>
.store-list {
	display: flex;
	flex-direction: column;
}

.flex {
	display: flex;
	flex-direction: column;
	gap: $spacing-m;
	justify-content: center;
}
.toggleOption {
	display: flex;
	gap: $spacing-m;
	align-items: center;
	margin-bottom: 8px;
}
</style>
